export const requiredField = (): string => {
  return "Este campo es requerido";
};

export const maxDateToDayField = (): string => {
  return "La fecha no puede ser mayor a hoy";
};

export const emailField = (): string => {
  return "Ingrese un correo electrónico válido";
};

export const minLength = (min: number): string => {
  return `El campo debe tener una longitud mínima de ${min}`;
};

export const maxLength = (max: number): string => {
  return `El campo debe tener una longitud máxima de ${max}`;
};

export const ageValidation = (): string => {
  return "El candidato debe tener al menos 18 años";
};
